export default __webpack_public_path__ + "static/media/sanstrom.6a20ddc5.png";